import { render, staticRenderFns } from "./video_demo.vue?vue&type=template&id=2d9548a2&scoped=true"
import script from "./video_demo.vue?vue&type=script&lang=js"
export * from "./video_demo.vue?vue&type=script&lang=js"
import style0 from "./video_demo.vue?vue&type=style&index=0&id=2d9548a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9548a2",
  null
  
)

export default component.exports